import { RefObject, useContext, useEffect } from 'react'
import { MapRef } from 'react-map-gl'
import { LocaleContext } from 'components/common/LocaleContext'

export const useLanguageSetter = (mapRef: RefObject<MapRef | null>) => {
  const { dateStringLocale } = useContext(LocaleContext)

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.setLanguage(dateStringLocale)
    }
  }, [mapRef, dateStringLocale])

  return null
}
